<template>
  <div class="comp-select-obj">
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="title-wrap">
            <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              v-focus="(initFocus && !hasAnswer)"
              @focus="initFocus = true"
              @blur="initFocus = false"
              class="title-style">
              <span>Question:</span> <br>
              {{content.data.title}}
            </p>
          </div>
        </v-flex>

        <v-flex xs12 class="object-wrap"
          v-bind:style="{ backgroundImage: 'url(' + require('../../assets/' + content.data.backgroundUrl) + ')' }"
        >
          <div role="button" class="select-object"
            v-for="(object, key) in content.data.objects"
            v-bind:key="key"
            v-bind:tabIndex="(enableTab) ? (key + 2) : -1"
            v-bind:style="{
              height: object.height + '%',
              width: object.width + '%',
              top: object.top + '%',
              left: object.left + '%'
            }"
            @click="checkAnswer(object)"
            @keyup.enter="checkAnswer(isCorrect)"
          >
            <img
              v-bind:src="require('../../assets/' + object.imageUrl)"
            />
            <div v-show="object.hasFound">CORRECT</div>
          </div>
        </v-flex>

        <v-flex xs12>
          <p v-bind:tabIndex="(enableTab) ? 1 : -1"
              class="title-style"
          >
            Item left: {{foundItem}} / {{totalScore}}
          </p>
        </v-flex>
      </v-layout>
    </v-container>
    <modal-ok
      :isShown="(hasAnswer && isCorrect)"
      @onClicked="nextStep"
    />
    <modal-ok
      :message="'Oops... Your answer is incorrect'"
      :buttonLabel="'Try Again'"
      :isShown="(hasAnswer && !isCorrect)"
      @onClicked="nextStep"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { focus } from 'vue-focus'
import ModalOk from '../../components/modal-ok/modalOk'

export default {
  name: 'SelectObject',
  directives: {
    focus: focus,
    focusing: {
      // directive definition
      inserted: function (el, bind) {
        alert(bind.value)
        if (bind.value) {
          console.log(el)
          el.focus()
        }
      }
    }
  },
  components: {
    ModalOk
  },
  data () {
    return {
      initFocus: false,
      enableTab: true,
      activeTabIndex: -1,
      hasAnswer: false,
      isCorrect: false,
      foundItem: 0
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: false,
      dafault: false
    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    totalScore () {
      let correctList = 0
      for (let index = 0; index < this.content.data.objects.length; index++) {
        const elem = this.content.data.objects[index]
        if (elem.isCorrect) {
          correctList++
        }
      }
      return correctList
    }
  },
  created () {
    this.$eventHub.$on('tab-pressed', () => {
      if (this.isActive) {
        this.activeTabIndex++
      }
      this.resetTabIndex()
    })

    this.$eventHub.$on('shift-tab-pressed', () => {
      if (this.isActive) {
        if (this.activeTabIndex > 0) {
          this.activeTabIndex--
        }
      }
      this.resetTabIndex()
    })
  },
  watch: {
    isActive () {
      if (this.isActive) {
        this.initFocus = true
        this.activeTabIndex = 1
      } else {
        this.activeTabIndex = -1
      }
    }
  },
  methods: {
    ...mapMutations([
      'nextSlide'
    ]),
    checkAnswer (object) {
      if (!object.hasFound && object.isCorrect) {
        this.foundItem++
        object.hasFound = true
      }

      if (this.foundItem === this.totalScore) {
        this.enableTab = false
        this.isCorrect = true
        this.hasAnswer = true
      }
      // this.enableTab = false
      // this.hasAnswer = true
      // this.isCorrect = object.isCorrect
      // this.deselectChoices(choice)
      // object.isSelected = true
    },
    deselectChoices (obj) {
      let responseList = this.content.data.responses
      for (let index = 0; index < responseList.length; index++) {
        console.log(obj)
        const element = responseList[index]
        element.isSelected = false
      }
    },
    nextStep () {
      if (this.isCorrect) {
        this.nextSlide()
      } else {
        this.initFocus = true
        this.enableTab = true
        this.hasAnswer = false
        this.isCorrect = false
      }
    },
    resetTabIndex () {
      if (document.hasFocus()) {
        if (document.activeElement.getAttribute('islast') === 'true') {
          this.activeTabIndex = 1
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/select-object/SelectObject.vue